<template>
  <div></div>
</template>

<script>
/**
 * @descripttion: 配置一些常用的方法和变量等
 * @Author: linyl
 * @Date: 2021-04-22 15:46:28
 */
import { _get, dateFormate2, getStorage, ActivityRoute } from '@/lib/utils'
export default {
  name: 'baseLayout',
  data() {
    return {}
  },
  mounted() {},
  methods: {
    _get,
    dateFormate2,
    getStorage,
    ActivityRoute
  }
}
</script>

<style lang="scss" scoped>
</style>
